// Hardcoded SEO-focused blog posts. Unique content (not copied from sinadicciones.org).
// Each post has schema markup at render time in BlogPost.jsx.

export const blogPosts = [
    {
        slug: "como-elegir-centro-rehabilitacion-drogas",
        title: "¿Cómo elegir un centro de rehabilitación de drogas en Chile?",
        description:
            "Guía paso a paso para elegir un centro de rehabilitación de drogas en Chile: criterios clínicos, acreditación, costos y señales de alerta.",
        author: "Equipo Editorial",
        datePublished: "2026-01-12",
        readingMinutes: 9,
        image: "https://images.unsplash.com/photo-1559757175-5700dde675bc?w=1200&q=80",
        keywords: [
            "centro de rehabilitación de drogas",
            "cómo elegir centro de rehabilitación",
            "rehabilitación Chile",
        ],
        sections: [
            {
                heading: "Antes de empezar: comprende la necesidad clínica",
                body:
                    "Elegir un centro de rehabilitación de drogas no es una decisión que deba tomarse por presión familiar o por el primer resultado de una búsqueda. El tipo de sustancia, el tiempo de consumo, las comorbilidades psiquiátricas y el entorno social determinan cuál es el dispositivo terapéutico apropiado. Antes de comparar centros, lo ideal es una evaluación por un médico especialista en adicciones o un psicólogo clínico con experiencia en trastornos por uso de sustancias.",
            },
            {
                heading: "Criterios no negociables",
                body:
                    "Un buen centro debe contar con equipo multidisciplinario (médico, psiquiatra, psicólogo, terapeuta), protocolos clínicos escritos, seguimiento post-alta y políticas claras contra tratos degradantes. La acreditación sanitaria de la SEREMI de Salud y la inscripción en registros como SENDA aportan respaldo verificable. Evita centros que no permiten visitas al recinto antes de ingresar a un familiar.",
            },
            {
                heading: "Modalidad: residencial, ambulatorio u online",
                body:
                    "La modalidad residencial (internado) es útil cuando hay riesgo vital, entorno no seguro o fracasos previos en ambulatorio. El ambulatorio intensivo permite mantener responsabilidades laborales o académicas. El formato online ha crecido con fuerza y es una alternativa real para casos leves a moderados, especialmente en zonas con poca oferta local.",
            },
            {
                heading: "Costos reales y transparencia",
                body:
                    "Un centro serio entrega presupuesto escrito, detalla qué incluye la mensualidad (hospedaje, terapias, medicación, exámenes) y qué queda fuera. Desconfía de precios muy bajos: pueden implicar menos horas terapéuticas, personal no titulado o infraestructura precaria. Los planes isapre y algunos convenios corporativos cubren parte del tratamiento; consúltalo siempre.",
            },
            {
                heading: "Señales de alerta",
                body:
                    "Ofrecer cura garantizada, rechazar visitas, pedir dinero en efectivo sin boleta, castigar con aislamiento prolongado o utilizar métodos físicos son señales claras de que debes descartar ese centro. La rehabilitación efectiva se construye sobre vínculo terapéutico y evidencia clínica, no sobre imposición.",
            },
        ],
        faq: [
            {
                q: "¿Cuánto dura un tratamiento de rehabilitación de drogas?",
                a: "La duración varía según el caso. En residencial lo habitual son 3 a 9 meses, mientras que el ambulatorio suele extenderse entre 6 y 18 meses con seguimiento posterior.",
            },
            {
                q: "¿Puedo obligar a un familiar a ingresar a un centro?",
                a: "En Chile solo procede la internación involuntaria bajo criterios médicos estrictos y autorización judicial. Lo recomendable es trabajar la motivación al cambio con un equipo profesional.",
            },
        ],
    },
    {
        slug: "tipos-tratamiento-adicciones",
        title: "Tipos de tratamiento para adicciones: ¿cuál es el adecuado?",
        description:
            "Conoce los principales tipos de tratamiento para adicciones en Chile: desintoxicación, comunidad terapéutica, ambulatorio intensivo y tratamiento online.",
        author: "Equipo Editorial",
        datePublished: "2026-01-20",
        readingMinutes: 8,
        image: "https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?w=1200&q=80",
        keywords: [
            "tipos de tratamiento adicciones",
            "comunidad terapéutica",
            "desintoxicación",
        ],
        sections: [
            {
                heading: "Desintoxicación médica",
                body:
                    "Es la primera fase cuando hay dependencia física (alcohol, benzodiacepinas, opioides). Se realiza en clínica u hospital con monitoreo 24/7 y medicación para reducir el síndrome de abstinencia. Rara vez supera los 10 días y no constituye por sí sola un tratamiento completo.",
            },
            {
                heading: "Comunidad terapéutica residencial",
                body:
                    "Modelo clásico chileno. Implica vivir en el centro entre 3 y 12 meses, con rutina estructurada, terapia individual y grupal, dinámicas familiares y reinserción progresiva. Es el formato de mayor evidencia en consumos severos o con policonsumo.",
            },
            {
                heading: "Ambulatorio intensivo",
                body:
                    "El usuario asiste varias veces por semana a sesiones grupales e individuales, manteniendo su vida cotidiana. Requiere una red familiar funcional y compromiso alto. Suele durar 6 a 12 meses y es la primera línea cuando el consumo es moderado.",
            },
            {
                heading: "Tratamiento online",
                body:
                    "Plataformas digitales con equipo clínico real entregan terapias por videollamada, material audiovisual y seguimiento asincrónico. Es útil en zonas con poca oferta, personas con alta carga laboral o pacientes que ya cursaron una fase residencial y requieren mantención.",
            },
            {
                heading: "Tratamiento dual",
                body:
                    "Cuando coexiste un trastorno psiquiátrico (depresión, bipolaridad, TLP, TDAH) con el consumo, el abordaje debe ser simultáneo. Elegir un centro con psiquiatra dentro del equipo evita recaídas asociadas a patología no tratada.",
            },
        ],
        faq: [
            {
                q: "¿Cuál es el tratamiento más efectivo?",
                a: "No existe uno universal. La efectividad depende del match entre severidad del consumo, comorbilidades y modalidad elegida. Una evaluación especializada es el mejor punto de partida.",
            },
        ],
    },
    {
        slug: "cuanto-cuesta-rehabilitacion-chile",
        title: "¿Cuánto cuesta la rehabilitación de drogas en Chile? Precios 2026",
        description:
            "Rangos reales de precios en centros de rehabilitación de drogas en Chile por modalidad, cobertura de isapre y alternativas públicas.",
        author: "Equipo Editorial",
        datePublished: "2026-02-02",
        readingMinutes: 7,
        image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=1200&q=80",
        keywords: [
            "cuánto cuesta rehabilitación Chile",
            "precio centro de rehabilitación",
            "rehabilitación isapre",
        ],
        sections: [
            {
                heading: "Rango general 2026",
                body:
                    "En centros privados, un tratamiento residencial en Chile oscila entre $1.500.000 y $4.500.000 mensuales. Los programas ambulatorios intensivos suelen ir de $250.000 a $900.000 al mes. Las plataformas online son más accesibles, con planes desde $150.000 mensuales. Estos valores varían según ciudad, acreditaciones y nivel de confort.",
            },
            {
                heading: "¿Qué debe incluir la mensualidad?",
                body:
                    "Un presupuesto transparente detalla: hospedaje y alimentación (en residencial), terapias individuales semanales, terapia grupal, medicación básica, exámenes de control y reuniones familiares. Actividades complementarias como deporte, arteterapia o mindfulness suelen estar incluidas en planes premium.",
            },
            {
                heading: "Cobertura de isapres y Fonasa",
                body:
                    "Varias isapres cuentan con convenios parciales para programas ambulatorios y hospitalarios cortos. Fonasa, a través de la Modalidad de Libre Elección, cubre consultas psiquiátricas y de psicología clínica en prestadores inscritos. Los tratamientos residenciales prolongados rara vez están cubiertos al 100%; pide copago estimado por escrito.",
            },
            {
                heading: "Alternativas públicas y gratuitas",
                body:
                    "SENDA ofrece programas gratuitos ambulatorios e intensivos con evaluación previa. Los CESFAM pueden derivar a la red de salud mental. En municipios grandes existen comunidades terapéuticas subvencionadas. El tiempo de espera suele ser el factor limitante.",
            },
        ],
        faq: [
            {
                q: "¿Existen créditos o financiamiento?",
                a: "Sí, varios centros trabajan con bancos o entregan planes de pago internos. Revisa la tasa efectiva anual antes de firmar.",
            },
        ],
    },
    {
        slug: "senales-necesitas-ayuda-profesional",
        title: "Señales de que necesitas ayuda profesional por consumo de drogas",
        description:
            "Identifica las señales físicas, emocionales y sociales que indican la necesidad de consultar a un profesional por consumo problemático de drogas.",
        author: "Equipo Editorial",
        datePublished: "2026-02-10",
        readingMinutes: 6,
        image: "https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=1200&q=80",
        keywords: [
            "señales de adicción",
            "consumo problemático",
            "ayuda profesional drogas",
        ],
        sections: [
            {
                heading: "Pérdida de control",
                body:
                    "Consumir más cantidad o durante más tiempo del que te habías propuesto, intentos fallidos de reducir el consumo o un fuerte deseo (craving) son criterios clínicos de dependencia. No se trata de voluntad, sino de neuroadaptación.",
            },
            {
                heading: "Deterioro funcional",
                body:
                    "Ausentismo laboral, bajo rendimiento académico, abandono de hobbies, conflictos familiares recurrentes y problemas legales son indicadores de que el consumo ha invadido áreas vitales. Si varios de ellos coexisten, la consulta no puede esperar.",
            },
            {
                heading: "Síntomas físicos y psicológicos",
                body:
                    "Temblor, insomnio, sudoración, ansiedad intensa, episodios depresivos, irritabilidad o pensamientos de muerte requieren evaluación inmediata. La combinación consumo + ideación suicida es una urgencia.",
            },
            {
                heading: "Mentir, esconder o minimizar",
                body:
                    "Cuando el consumo se oculta a personas cercanas, se consume a solas o se minimiza sistemáticamente ante comentarios del entorno, es probable que ya exista un trastorno por uso de sustancias.",
            },
            {
                heading: "¿Qué hacer primero?",
                body:
                    "Agendar una consulta con un psicólogo clínico o médico especializado en adicciones. No hace falta estar en crisis para pedir ayuda: mientras antes se interviene, menor es el costo emocional y el riesgo de complicaciones.",
            },
        ],
        faq: [
            {
                q: "¿Puedo pedir ayuda sin ingresar a un centro residencial?",
                a: "Sí. La mayoría de los casos se inician en ambulatorio. La internación se reserva para situaciones de mayor complejidad.",
            },
        ],
    },
    {
        slug: "diferencia-ambulatorio-residencial",
        title: "Diferencia entre tratamiento ambulatorio y residencial",
        description:
            "Comparativa clara entre tratamiento ambulatorio y residencial para adicciones en Chile: ventajas, limitaciones y cuándo elegir cada uno.",
        author: "Equipo Editorial",
        datePublished: "2026-02-18",
        readingMinutes: 6,
        image: "https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=1200&q=80",
        keywords: [
            "ambulatorio vs residencial",
            "internado rehabilitación",
            "tratamiento adicciones",
        ],
        sections: [
            {
                heading: "¿Qué es cada modalidad?",
                body:
                    "El tratamiento residencial implica vivir en el centro durante semanas o meses. El ambulatorio permite continuar con la vida cotidiana mientras se asiste a sesiones en horarios definidos. Ambas modalidades pueden ser eficaces; la elección depende de factores clínicos y sociales.",
            },
            {
                heading: "Cuándo elegir residencial",
                body:
                    "Recomendable cuando existe riesgo vital, entorno no protector, intentos ambulatorios fallidos, policonsumo severo o comorbilidad psiquiátrica descompensada. Permite un corte brusco con el contexto de consumo y una estructura rigurosa.",
            },
            {
                heading: "Cuándo elegir ambulatorio",
                body:
                    "Adecuado si hay red familiar funcional, trabajo o estudios que sostener, consumo de severidad leve a moderada y motivación al cambio. Es más económico y mantiene la autonomía, pero exige mayor compromiso personal.",
            },
            {
                heading: "Combinación secuencial",
                body:
                    "En muchos casos se inicia con residencial y se continúa en ambulatorio o en programas de mantención online. Esta secuencia mejora significativamente las tasas de recuperación sostenida y reduce el riesgo de recaída a 12 meses.",
            },
        ],
        faq: [
            {
                q: "¿Puedo cambiar de modalidad durante el tratamiento?",
                a: "Sí. Los cambios de modalidad son habituales y responden a la evolución clínica. Siempre deben ser planificados con el equipo tratante.",
            },
        ],
    },
];

export function getPostBySlug(slug) {
    return blogPosts.find((p) => p.slug === slug) || null;
}
